<template>
  <div
    v-if="hasDescription || hasTildaParameters"
    class="comment"
  >
    <template v-if="hasDescription">
      <p
        v-for="description in splitedDescription"
        :key="description"
        v-html="description"
      ></p>
    </template>
    <template v-if="isTildaShown">
      <div
        class="tilda-container"
        :class="{ 'tilda-indent': hasDescription }"
      >
        <tilda-view :tilda="tildaParameters"></tilda-view>
      </div>
    </template>
  </div>
</template>

<script>
import TildaView from '@/components/TildaView';

const SLICE_LENGTH = 250;

export default {
  name: 'PaymentDescription',
  props: {
    description: {
      type: String,
      default() {
        return '';
      },
    },
    tildaParameters: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    TildaView,
  },
  data() {
    return {
      showFullDescription: false,
    };
  },
  computed: {
    splitedDescription() {
      return this.description.split('\n');
    },
    hasDescription() {
      return this.$validate.isNotEmptyString(this.description);
    },
    isLongDescription() {
      return this.description.length > SLICE_LENGTH;
    },
    hasTildaParameters() {
      return this.$validate.isNotEmptyObject(this.tildaParameters);
    },
    isTildaShown() {
      if (this.hasTildaParameters) {
        return this.isLongDescription ? this.showFullDescription : true;
      }

      return false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .comment
    margin-bottom: 10px
    padding: 20px
    border-radius: 5px
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)

    p
      font-size: 14px
      line-height: 20px
      color: #212121
      word-break: break-word

  p.description-toogle-text
    color: #9b51e0
    cursor: pointer

  .tilda-indent
    margin-top: 10px
</style>
